import { useEffect, useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import { formatTimeRu } from "../../../utils/appointmentLabels";
import s from "../clinic.module.css";
import { Button, Field, Input, Select, useToast } from "../../ui";

const FALLBACK_DURATION = 30;

export default function AdminDoctorSlotPreview({ doctorId, branchId, branches }) {
  const toast = useToast();
  const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10));
  const [branch, setBranch] = useState(branchId || "");
  const [serviceId, setServiceId] = useState("");
  const [services, setServices] = useState([]);
  const [slots, setSlots] = useState([]);
  const [slotDuration, setSlotDuration] = useState(FALLBACK_DURATION);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (branchId) setBranch(branchId);
  }, [branchId]);

  useEffect(() => {
    clinicAPI.getDoctorServices(doctorId).then((r) => {
      const list = r.services || [];
      const assigned = list.filter((x) => x.assigned);
      setServices(assigned.length ? assigned : list);
    });
  }, [doctorId]);

  const selectedService = services.find((sv) => sv.id === serviceId);

  const load = () => {
    if (!branch || !date) return;
    setLoading(true);
    clinicAPI
      .getDoctorSlotPreview(doctorId, {
        date,
        branch_id: branch,
        service_id: serviceId || undefined,
      })
      .then((r) => {
        setSlots(r.slots || []);
        setMessage(r.message || "");
        if (r.duration_minutes) setSlotDuration(r.duration_minutes);
      })
      .catch((e) => toast.error(e.response?.data?.error || "Ошибка"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (doctorId && branch && date) load();
  }, [doctorId, branch, date, serviceId]);

  const durationHint = selectedService
    ? `Длительность занятия: ${selectedService.duration_minutes ?? selectedService.default_duration} мин («${selectedService.name}»)`
    : `Услуга не выбрана — для расчёта слотов используется ${slotDuration} мин (стандарт, если у услуги нет своей длительности)`;

  return (
    <div className={s.previewCard}>
      <div className={s.previewCardHead}>
        <div>
          <h4 className={s.docSectionTitle} style={{ margin: 0 }}>
            Превью для клиента
          </h4>
          <p className={s.docSectionHint} style={{ margin: "4px 0 0" }}>
            Такие слоты увидят на портале записи
          </p>
        </div>
        <span className={s.previewCount}>
          {loading ? "…" : `${slots.length} слотов`}
        </span>
      </div>
      <div className={s.previewFilters}>
        <Field label="Дата">
          <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
        </Field>
        <Field label="Зал">
          <Select value={branch} onChange={(e) => setBranch(e.target.value)}>
            {(branches || []).map((b) => (
              <option key={b.id} value={b.id}>
                {b.name}
              </option>
            ))}
          </Select>
        </Field>
        <Field label="Услуга для расчёта" hint="Длительность слота = длительность услуги">
          <Select value={serviceId} onChange={(e) => setServiceId(e.target.value)}>
            <option value="">— выберите услугу —</option>
            {services.map((sv) => {
              const min = sv.duration_minutes ?? sv.default_duration;
              return (
                <option key={sv.id} value={sv.id}>
                  {sv.name} ({min} мин)
                </option>
              );
            })}
          </Select>
        </Field>
      </div>
      <p className={s.previewDurationNote}>{durationHint}</p>
      <div className={s.previewSlotsArea}>
        {loading ? (
          <p className={s.docEmptyHint}>Загрузка…</p>
        ) : !serviceId ? (
          <p className={s.docEmptyHint}>
            Выберите услугу, чтобы увидеть слоты с правильной длительностью занятия
          </p>
        ) : slots.length === 0 ? (
          <p className={s.docEmptyHint}>{message || "Нет свободных слотов"}</p>
        ) : (
          <div className={s.previewSlotGrid}>
            {slots.map((sl) => (
              <span key={sl.start_datetime} className={s.previewSlot}>
                {formatTimeRu(sl.start_datetime)}
                {sl.manual && <em className={s.previewSlotTag}>ручной</em>}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
